import React, { useState } from 'react';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import { useNavigate } from 'react-router-dom';
import { useTheme } from "@mui/material";

function SmallCard({ outlined, header, to }) {
    const navigate = useNavigate();
    const [isHovered, setIsHovered] = useState(false);
    const theme = useTheme();
    const isDarkTheme = theme.palette.mode === 'dark';

    const outlinedCardStyle = {
        minHeight: '60px',
        cursor: 'pointer',
        padding: '16px',
        boxShadow: 'none',
        backgroundColor: isDarkTheme ? '#000000' : '#FFFFFF',
        color: isDarkTheme ? '#FFFFFF' : '#000000',
        border: isHovered ? `2px solid #008DFC` : `2px solid ${isDarkTheme ? '#FFFFFF' : '#000000'}`
    };

    const nonOutlinedCardStyle = {
        minHeight: '60px',
        cursor: 'pointer',
        padding: '16px',
        boxShadow: 'none',
        backgroundColor: isDarkTheme ? '#FFFFFF' : '#000000',
        color: isDarkTheme ? '#000000' : '#FFFFFF',
        border: isHovered ? `2px solid #008DFC` : `2px solid ${isDarkTheme ? '#FFFFFF' : '#000000'}`
    };

    const handleClick = () => {
        if (to) {
            console.log(to.substring(0, 3).toLowerCase())
            if (to.substring(0, 4).toLowerCase() === 'http') {
                window.location.href = to;
            }
            else {
                navigate(`/${to}`);
            }
        };
    }

    return (
        <Card sx={outlined ? outlinedCardStyle : nonOutlinedCardStyle} onClick={handleClick} onMouseOver={() => setIsHovered(true)} onMouseOut={() => setIsHovered(false)}>
            <Typography variant={'h4'} style={{ textAlign: 'center' }}>{header}</Typography>
        </Card>
    );
};

export { SmallCard };
